import { FolderViewResponse } from "../../interfaces/ViewFolderResponse";
import { GetFolderTypeFromScopeType, GetViewTypeFromScopeType } from "./MappingUtilities";
import { ICustomFilterQuery } from "../../interfaces/Slice.types";
import { MapQueryGroupSchema } from "./MapQueryGroupSchema";
import { MapDisplayColumns } from "./MapDisplayColumns";

export const mapCustomFilter = (folderView: FolderViewResponse): ICustomFilterQuery => {
    const mappedCustomFilterQuery: ICustomFilterQuery = {
        id: folderView.id,
        name: folderView.Name,
        tenantId: folderView?.TenantId,
        queryGroups: folderView.QueryGroups ? MapQueryGroupSchema(folderView.QueryGroups) : [],
        groupsInfo: folderView.GroupsInfo ?? [],
        displayColumn: MapDisplayColumns(folderView.DisplayColumns ?? []),
        //legacyId: folderView.Id, //TODO: Legacy id must be used to run /Search API
        parentId: folderView.ParentId ?? null,
        createdOn: null,
        createdBy: null,
        isFavorite: false,
        isDefault: false,
        viewGroupID: null,
        default: false,
        type: GetViewTypeFromScopeType(folderView.ScopeType), //Default to user, manually change
        adoFolderId: null,
        temporaryViewID: null,
        analytics: null,
        gridFormat: null,
        children: null,
        adoQueryId: null,
        wiql: null,
        expiredOn: null,
    };

    return mappedCustomFilterQuery;
}